import { Typography } from '@mui/material';
import React from 'react';

import { FormToggleLabelContainer } from '@/shared/components/ui/form/components/form-toggle/form-toggle.styled';
import {
  StyledSwitch,
  ToggleContainer,
} from '@/shared/components/ui/form/components/toggle/toggle.styled';
import {
  TToggleLabelColor,
  TToggleLabelPosition,
  TToggleProps,
} from '@/shared/components/ui/form/components/toggle/toggle.types';
import { Tooltip } from '@/shared/components/ui/tooltip/tooltip';

export const Toggle: React.FC<TToggleProps> = ({
  leftLabel,
  rightLabel,
  disabled = false,
  checked = false,
  tooltip,
  ...props
}) => {
  const getLabelColor = (position: TToggleLabelPosition): TToggleLabelColor => {
    if (disabled) {
      return 'textDisabled';
    }

    if (position === 'left') {
      return checked ? 'textSecondary' : 'primary';
    }

    return checked ? 'primary' : 'textSecondary';
  };

  const renderLabel = (label: string, position: TToggleLabelPosition) => {
    return (
      <FormToggleLabelContainer $position={position}>
        <Typography variant="p7" color={getLabelColor(position)}>
          {label}
        </Typography>
      </FormToggleLabelContainer>
    );
  };

  // Two labels name the two states, so clicking either would flip away from the
  // one it names; only a single descriptive label is safe to make clickable.
  const isLabelClickable = !leftLabel || !rightLabel;

  const renderToggle = () => (
    <ToggleContainer
      as={isLabelClickable ? 'label' : 'span'}
      $clickable={isLabelClickable && !disabled}
    >
      {leftLabel && renderLabel(leftLabel, 'left')}
      <StyledSwitch checked={checked} disabled={disabled} {...props} />
      {rightLabel && renderLabel(rightLabel, 'right')}
    </ToggleContainer>
  );

  if (!tooltip) {
    return renderToggle();
  }

  return <Tooltip title={tooltip}>{renderToggle()}</Tooltip>;
};
